import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-link" }, null, -1)

import { computed } from "vue";
import type { SizeType } from "ant-design-vue/es/config-provider";

interface Props {
  modelValue?: string;
  placeholder?: string;
  disabled?: boolean;
  size?: SizeType;
  allowClear?: boolean;
  maxlength?: number;
  status?: "" | "error" | "warning";
  validateOnBlur?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UrlInput',
  props: {
    modelValue: { default: "" },
    placeholder: { default: "https://example.com" },
    disabled: { type: Boolean, default: false },
    size: { default: "middle" },
    allowClear: { type: Boolean, default: true },
    maxlength: { default: 2048 },
    status: { default: "" },
    validateOnBlur: { type: Boolean, default: true }
  },
  emits: ["update:modelValue", "blur", "pressEnter", "change", "validate"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isValidUrl = (url: string) => {
  if (!url) return true;
  try {
    const parsed = new URL(url);
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch {
    return false;
  }
};

const localError = computed(() => {
  if (!props.validateOnBlur) return false;
  return !!props.modelValue && !isValidUrl(props.modelValue);
});

const computedStatus = computed(() => {
  if (props.status) return props.status;
  return localError.value ? "error" : "";
});

const innerValue = computed({
  get: () => props.modelValue ?? "",
  set: (val: string) => {
    emit("update:modelValue", val);
    emit("change", val);
  },
});

const onBlur = (e: FocusEvent) => {
  emit("validate", isValidUrl(props.modelValue ?? ""));
  emit("blur", e);
};

const onPressEnter = (e: KeyboardEvent) => emit("pressEnter", e);

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createBlock(_component_a_input, {
    value: innerValue.value,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((innerValue).value = $event)),
    type: "url",
    placeholder: _ctx.placeholder,
    disabled: _ctx.disabled,
    size: _ctx.size,
    "allow-clear": _ctx.allowClear,
    maxlength: _ctx.maxlength,
    status: computedStatus.value,
    class: "ant-url-input",
    onBlur: onBlur,
    onPressEnter: onPressEnter
  }, {
    prefix: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["value", "placeholder", "disabled", "size", "allow-clear", "maxlength", "status"]))
}
}

})